<template>
  <v-app-bar app color="#ffd1b3" dark height="50">
    <v-app-bar-nav-icon @click="deActivateDrawer">
      <v-icon color="black">mdi-menu</v-icon>
    </v-app-bar-nav-icon>
    <v-toolbar-title class="v-app-bar-title" style="color: black !important">پنل کاربری</v-toolbar-title>
    <v-spacer />
    <v-menu allow-overflow left content-class="dropdown-menu" offset-y transition="slide-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text color="#E4B363" style="margin-left: 5px" height="50" v-bind="attrs" v-on="on">
          <span style="color: black; margin-left: 10%"> خوش آمدید</span>
          <v-icon color="black">mdi-account</v-icon>
        </v-btn>
      </template>
      <v-card style="margin-top: 5px">
        <v-list class="accountList">
          <v-list-item style="cursor: pointer" @click="logout">
            <v-list-item-action style="min-width: 30px !important">
              <v-icon color="#263238">mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-title class="itemTitle">خروج</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>
<script>
export default {
  name: "AppBar",
  methods: {
    deActivateDrawer() {
      if (
        this.$store.state.drawer == true &&
        this.$store.state.expandOnHover == true
      ) {
        this.$store.state.expandOnHover = false;
      } else if (
        this.$store.state.drawer == true &&
        this.$store.state.expandOnHover == false
      ) {
        this.$store.state.drawer = false;
      } else {
        this.$store.state.drawer = true;
        this.$store.state.expandOnHover = false;
      }
    },
    logout() {
      this.$store.commit("SET_USERINFO", {});
      this.$store.commit("SET_ISAUTHENTICATED", false);
      this.$router.replace({ name: "Login" });
    },
  },
};
</script>
